import _ from 'lodash';

export default (Model, leech) => {
  const Controllers = {};

  Controllers.renderAdminPage = function renderAdminPage(req, res) {
    /*
      Make sure the route matches your path to template exactly.

      If your route was:
      myforum.com/some/complex/route/
      your template should be:
      templates/some/complex/route.tpl
      and you would render it like so:
      res.render('some/complex/route');
    */

    res.render('admin/plugins/leech-tool', {
      models: Object.keys(Model.s),
      renderersFromModel: Model.mapToRenderers,
    });
  };

  Controllers.leechToolAPI = (req, res) => {
    const sendJSON = _.bind(res.json, res);
    leech(req)
      .catch(console.log)
      .then(sendJSON, sendJSON);
  };

  return Controllers;
};
